import React from 'react';
import { Formik, Form } from 'formik';
import * as Yup from 'yup';

import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import EditIcon from '@material-ui/icons/Edit';
import { Alert, AlertTitle } from '@material-ui/lab';

import useModal from '../../../hooks/useModal';
import { TextField, Card, FormikArrayTextField, Loading } from '../../../Components/Base';

import { assessmentDetailFields as fields } from './utils';

const EditInstructionsModal = ({ values, onUpdate, onClose, open }) => {
  const fieldName = fields.instructions.fieldName;
  return (
    <Formik
      initialValues={{ [fieldName]: values }}
      onSubmit={async (values) => {
        await onUpdate(values);
        onClose();
      }}
      enableReinitialize={true}
      validateOnChange={true}
      validationSchema={Yup.object().shape({
        [fieldName]: fields.instructions.validationSchema,
      })}
    >
      {(formikProps) => {
        return (
          <Form>
            <Dialog
              open={open}
              disableBackdropClick
              onClose={onClose}
              fullWidth={true}
              maxWidth={'sm'}
            >
              <DialogTitle>แก้ไข Instructions</DialogTitle>
              <DialogContent dividers>
                <FormikArrayTextField
                  readOnly={false}
                  disabled={false}
                  fieldName={fieldName}
                  values={formikProps.values}
                  disableAddRemove={false}
                  disableReorder={false}
                  addItemText={'เพิ่ม Instructions'}
                />
              </DialogContent>
              <DialogActions>
                <Button
                  onClick={() => {
                    formikProps.resetForm();
                    onClose();
                  }}
                  disabled={formikProps.isSubmitting}
                  type={'button'}
                >
                  ยกเลิก
                </Button>
                <Button
                  type={'submit'}
                  onClick={formikProps.handleSubmit}
                  color="primary"
                  variant={'contained'}
                  disabled={formikProps.isSubmitting || !formikProps.dirty}
                >
                  ยืนยันการแก้ไข
                </Button>
              </DialogActions>
              <Loading.Modal open={formikProps.isSubmitting} />
            </Dialog>
          </Form>
        );
      }}
    </Formik>
  );
};

const Instructions = ({ textFieldProps, onUpdate, instructions }) => {
  const { modalOpen, handleModalOpen, handleModalClose } = useModal();

  return (
    <Card>
      <Card.Header
        title={'ข้อมูล Instructions'}
        action={
          <Button
            aria-label="edit"
            color={'secondary'}
            startIcon={<EditIcon />}
            onClick={handleModalOpen}
          >
            แก้ไข
          </Button>
        }
      />
      <Card.Content style={{ paddingTop: 0 }}>
        <Alert severity="info">
          <AlertTitle>Info</AlertTitle>
          ข้อมูลนี้จะถูกแสดงผลเป็นลิสต์ ในส่วน <strong>“ก่อนเริ่มทำแบบทดสอบ”</strong> ในหน้า Cover
          ของแบบทดสอบ หากไม่กำหนดระบบจะเว้นว่างลิสต์ของส่วนนั้นไว้
        </Alert>
      </Card.Content>

      <Card.Content>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            {instructions.length > 0 ? (
              instructions.map((value) => {
                return (
                  <Box mb={3} key={value}>
                    <TextField
                      value={value}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      readOnly={true}
                      fullWidth={true}
                      {...textFieldProps}
                    />
                  </Box>
                );
              })
            ) : (
              <Typography variant={'subtitle1'}>
                ยังไม่มีข้อมูล Instructions คลิกปุ่ม <strong>"แก้ไข"</strong> เพื่อเพิ่มข้อมูล
              </Typography>
            )}
            <EditInstructionsModal
              open={modalOpen}
              values={instructions}
              onUpdate={onUpdate}
              onClose={handleModalClose}
            />
          </Grid>
        </Grid>
      </Card.Content>
    </Card>
  );
};

Instructions.defaultProps = {
  instructions: [],
  onUpdate: () => {},
};

export default Instructions;
